export default __webpack_public_path__ + "ba2cc40b37b35603a3cbe08fbe6baddd.jpeg";